import { DaterangepickerComponent } from 'ngx-daterangepicker-material';

/**
 * This patch fixes the "Cannot read properties of undefined (reading 'selectedHour')" error
 * when selecting only a start date with the daterangepicker.
 * 
 * It also ensures that:
 * If only a start date is selected, the end date is set to the same value
 */
export function applyDaterangepickerPatch() {
  try {
    const originalClickApply = DaterangepickerComponent.prototype.clickApply;
    
    DaterangepickerComponent.prototype.clickApply = function(this: any, e?: MouseEvent) {
      if (this.startDate && !this.endDate && !this.timePicker) {
        this.endDate = this.startDate.clone();
      }
      
      // Only update the label for range pickers (not single date pickers)
      if (this.startDate && this.endDate && !this.singleDatePicker) {
        if (this.locale) {
          const format = this.locale.displayFormat || this.locale.format || 'YYYY-MM-DD';
          const separator = this.locale.separator || ' - ';
          this.chosenLabel = this.startDate.format(format) + separator + this.endDate.format(format);
        } else {
          this.chosenLabel = this.startDate.format('YYYY-MM-DD') + ' - ' + this.endDate.format('YYYY-MM-DD');
        }
      }
      
      const result = originalClickApply.call(this, e);
      return result;
    };
        
  } catch (error) {
    console.error('[DaterangepickerPatch] Error applying patch:', error);
  }
}
